import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack
} from '@mui/material';
import { useAtom } from 'jotai';

import { rolesDialogOpenAtom } from '../../pages/Administration/Users/Users.store';
import { RolePermissionsGlobalMatrix } from './RolePermissionsGlobalMatrix';

const RolePermissionsDialog = () => {
  const [rolesDialogOpen, setRolesDialogOpen] = useAtom(rolesDialogOpenAtom);

  const handleClose = () => {
    setRolesDialogOpen(false);
  };

  return (
    <Dialog open={rolesDialogOpen} onClose={handleClose} maxWidth="xl">
      <DialogTitle>
        <Stack direction="row" sx={{ alignItems: 'center', gap: 1 }}>
          <FontAwesomeIcon icon={faInfoCircle} style={{ opacity: 0.25 }} />
          Roles and Permissions
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ maxHeight: '65vh' }}>
        <RolePermissionsGlobalMatrix />
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'end', padding: '16px' }}>
        <Button onClick={handleClose} variant="contained" color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RolePermissionsDialog;
